import React from 'react';
import Chip from '@material-ui/core/Chip';
import T from 'i18n-react';
import useTheme from '@material-ui/core/styles/useTheme';

type CategoryChipProps = {
  name?: string,
  color?: string,
  width?: string | number,
  maxWidth?: string | number,
  minWidth?: string | number,
};

const CategoryChip = ({
  name,
  color,
  width = 120,
  maxWidth = 'auto',
  minWidth = 'auto',
}: CategoryChipProps) => {
  const theme = useTheme();

  return (
    <Chip
      label={name || T.translate('other')}
      style={{
        color: theme.palette.common.white,
        backgroundColor: color || theme.palette.grey[500],
        width: width,
        maxWidth: maxWidth,
        minWidth: minWidth,
        height: 22,
        lineHeight: 1.5,
        borderRadius: 20,
        fontSize: 12,
        fontWeight: 'bold',
      }}
    />
  );
};

export default CategoryChip;
